import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Radio,
} from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import InputMoney from '../../components/InputMoney/InputMoney';
import Loading from '../../components/Loading';
import RentPurposeSelect from '../booking/RentPurposeSelect';
import BookingApi, {
  bookingPurposes,
} from '../../functions/api/booking/BookingApi';
import CityApi from '../../functions/api/partner/CityApi';
import UserApi from '../../functions/api/user/UserApi';
import TypeApi from '../../functions/api/vehicle/TypeApi';
import {
  CustomSelect,
  filterOption,
  normalizeOptions,
} from './form/CustomSelect';
import FormBookingUnsureGroup from './FormBookingUnsureGroup';
import MyUtil from '../../functions/MyUtil';

function FormBooking(props) {
  const [form] = Form.useForm();
  const { bookingCode } = useParams();

  const [booking, setBooking] = useState(false);
  const [filterOptions, setFilterOptions] = useState({});
  const [selectedCity, setSelectedCity] = useState();
  const [selectedType, setSelectedType] = useState();

  const [customerType, setCustomerType] = useState('personal');
  const [showDeliveryPoint, setShowDeliveryPoint] = useState(false);
  const [showVatInvoice, setShowVatInvoice] = useState(false);

  useEffect(() => {
    fetchSelectOptions().then(setFilterOptions);

    if (bookingCode) {
      BookingApi.getBookingByCode(bookingCode).then(async (b) => {
        const actualRentalDate = moment(b.book_rental_date_actual);
        const actualReturnDate = moment(b.book_return_date_actual);

        const parsedBooking = {
          ...b,
          book_retun_date: moment(b.book_retun_date),
          book_rent_date: moment(b.book_rent_date),
          book_return_date_actual: actualReturnDate.isValid()
            ? actualReturnDate
            : undefined,
          book_rental_date_actual: actualRentalDate.isValid()
            ? actualRentalDate
            : undefined,
        };

        const isBusiness =
          parsedBooking.vat_company_name ||
          parsedBooking.vat_company_address ||
          parsedBooking.vat_company_tax_code ||
          parsedBooking.vat_company_mail;

        if (isBusiness) {
          setCustomerType('business');
          form.setFieldsValue({ customer_type: 'business' });
        } else {
          setCustomerType('personal');
          form.setFieldsValue({ customer_type: 'personal' });
        }

        setBooking(parsedBooking);

        // Kiểm tra nếu có thông tin giao xe tại nhà thì hiển thị trường điểm giao xe
        if (
          parsedBooking.cstm_deli_addr &&
          parsedBooking.cstm_deli_addr.trim() !== ''
        ) {
          setShowDeliveryPoint(true);
        }

        // Kiểm tra nếu có thông tin VAT thì hiển thị phần xuất hóa đơn VAT
        if (
          parsedBooking.vat_company_name ||
          parsedBooking.vat_company_address ||
          parsedBooking.vat_company_tax_code ||
          parsedBooking.vat_company_mail
        ) {
          setShowVatInvoice(true);
        }
      });
    }
  }, []);

  function resetActualData() {
    form.setFieldsValue({ part_id_actual: null, vhc_part_id_actual: null });
  }

  function handleDeliveryAddressChange(e) {
    const value = e.target.value;
    setShowDeliveryPoint(value && value.trim() !== '');
  }

  function handleVatInfoChange() {
    const vatCompanyName = form.getFieldValue('vat_company_name');
    const vatCompanyAddress = form.getFieldValue('vat_company_address');
    const vatCompanyTaxCode = form.getFieldValue('vat_company_tax_code');
    const vatCompanyMail = form.getFieldValue('vat_company_mail');

    const hasVatInfo =
      vatCompanyName ||
      vatCompanyAddress ||
      vatCompanyTaxCode ||
      vatCompanyMail;
    setShowVatInvoice(hasVatInfo);
  }
  function onPartnerChange(partner) {
    let commission = partner?.commission ?? null;

    if ('string' === typeof commission) {
      commission = '';
    }

    form.setFieldsValue({ commission });
  }

  const formItemLayout = {
    wrapperCol: { span: 24 },
    labelCol: { span: 24 },
  };

  async function updatePartnerFilter({ city, type }) {
    setSelectedCity(city || form.getFieldValue('city_id'));
    setSelectedType(type || form.getFieldValue('vhc_type_id'));
  }

  async function submitForm(values) {
    let result;

    const payload = {
      ...values,
      book_deli_form_id: values.cstm_deli_addr ? 1 : 0, // TODO: improve this method
      part_id:
        bookingCode && (values.part_id === null || undefined)
          ? values.part_id_actual
          : values.part_id,
      vhc_part_id:
        bookingCode && (values.vhc_part_id === null || undefined)
          ? values.vhc_part_id_actual
          : values.vhc_part_id,
    };

    delete payload.vhc_part_day_price;
    delete payload.customer_type;
    if (values.customer_type === 'personal') {
      payload.vat_company_name = null;
      payload.vat_company_address = null;
      payload.vat_company_tax_code = null;
      payload.vat_company_mail = null;
    }

    // console.log('Payload gửi đi:', payload);

    try {
      if (bookingCode) {
        result = await BookingApi.editBooking(payload);
      } else {
        result = await BookingApi.createBooking(payload);
      }

      if (!result.data) {
        throw new Error(result.message ?? result);
      }

      message.success(`Đã lưu booking ${result.data.book_code}`);

      props.history.push('/booking');
    } catch (e) {
      message.error(e.message);
    }
  }

  function calculateTotal() {
    const dayActual = form.getFieldValue('book_day_num_actual') || 0;
    const priceActual = form.getFieldValue('vhc_part_day_price') || 0;
    form.setFieldsValue({
      book_price_total_actual: dayActual * priceActual,
    });

    calculateRevenue();
  }

  function getCommissionValue(totalPrice) {
    const commission = form.getFieldValue('commission');

    if (typeof commission === 'string') {
      return 0;
    }

    if (undefined === commission) {
      return 0;
    }

    if (commission < 100) {
      return (commission * totalPrice) / 100;
    }

    return Number(commission);
  }

  function getPromoValue(totalPrice) {
    const promo = form.getFieldValue('promo_val');

    if (undefined === promo) {
      return 0;
    }

    if (promo < 100) {
      return (promo * totalPrice) / 100;
    }

    return Number(promo);
  }

  function calculateRevenue() {
    const bookPriceTotalActual =
      form.getFieldValue('book_price_total_actual') || 0;
    const commissionValue = getCommissionValue(bookPriceTotalActual);
    const promoValue = getPromoValue(bookPriceTotalActual);

    const revenue = commissionValue - promoValue;

    form.setFieldsValue({ revenue });
  }

  function failReasonDidChange(failReasonId) {
    const selected = reasons.find((r) => r.book_resn_id === failReasonId);
    form.setFieldsValue({ book_resn_name: selected.book_resn_name });
  }
  const { cities, sources, types, reasons, operators } = filterOptions;

  if (bookingCode && !booking) {
    return <Loading />;
  }

  if (isEmpty(cities)) {
    return <Loading />;
  }

  let description = null;
  if (!isEmpty(booking.bookingDuplicates)) {
    description = (
      <ul>
        {booking.bookingDuplicates.map((item) => {
          return (
            <li>
              <a
                target="_blank"
                href={`${window.location.origin}/booking/edit-booking/${item.book_code}`}
              >
                {item.book_code}
              </a>
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <>
      <h1>{bookingCode ? `Sửa booking ${bookingCode}` : 'Thêm booking'}</h1>
      {null !== description && (
        <Alert
          message="Có thể trùng với các booking sau:"
          description={description}
          type="warning"
        />
      )}
      <Form
        className="bg-grey"
        form={form}
        {...formItemLayout}
        initialValues={booking}
        onFinish={submitForm}
      >
        <Card className="mb-3">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['cstm_name']}
                label="Tên khách hàng"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="mb-0"
                name={['cstm_phon']}
                label="Số điện thoại"
                rules={[{ required: true }]}
              >
                <Input type="phone" />
              </Form.Item>
              <Form.Item
                name={['is_returning_customer']}
                valuePropName="checked"
              >
                <Checkbox>Khách cũ</Checkbox>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['cstm_emai']}
                label="Email"
                rules={[{ type: 'email' }]}
              >
                <Input type="email" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['book_src_key']}
                label="Đến từ nguồn"
                rules={[{ required: true }]}
              >
                <CustomSelect
                  dataSource={sources}
                  labelField="book_src_key"
                  valueField="book_src_key"
                  form={form}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Yêu cầu khác"
                name="customer_type"
                rules={[{ required: true }]}
              >
                <Radio.Group
                  value={customerType}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setCustomerType(selected);
                    form.setFieldsValue({ customer_type: selected });

                    // if (selected === 'personal') {
                    //   form.setFieldsValue({
                    //     vat_company_name: undefined,
                    //     vat_company_address: undefined,
                    //     vat_company_tax_code: undefined,
                    //     vat_company_mail: undefined,
                    //   });
                    // }
                  }}
                >
                  <Radio value="personal">Cá nhân</Radio>
                  <Radio value="business">Doanh nghiệp</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row> */}
          {/* vat cho doanh nghiệp */}
          {showVatInvoice && (
            <div style={{ marginBottom: '16px' }}>
              <h5
                style={{
                  fontWeight: 'bold',
                  color: '#000',
                  marginBottom: '8px',
                }}
              >
                Xuất hóa đơn VAT
              </h5>
            </div>
          )}
          {customerType === 'business' && (
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item name={['vat_company_name']} label="Tên doanh nghiệp">
                  <Input onChange={handleVatInfoChange} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['vat_company_address']}
                  label="Địa chỉ công ty"
                >
                  <Input onChange={handleVatInfoChange} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={['vat_company_tax_code']} label="Mã số thuế">
                  <Input onChange={handleVatInfoChange} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={['vat_company_mail']}
                  label="Email doanh nghiệp"
                  rules={[{ type: 'email' }]}
                >
                  <Input type="email" onChange={handleVatInfoChange} />
                </Form.Item>
              </Col>
            </Row>
          )}
          {showDeliveryPoint && (
            <Col span={6}>
              <Form.Item
                name="cstm_deli_addr"
                label={<h5 style={{ fontWeight: 'bold' }}>Giao xe tại nhà</h5>}
              >
                <Input onChange={handleDeliveryAddressChange} />
              </Form.Item>
            </Col>
          )}
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="city_id"
                label="Thuê tại thành phố"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  onChange={updatePartnerFilter}
                  filterOption={filterOption}
                  options={normalizeOptions('city_name', 'city_id', cities)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="vhc_type_id"
                label="Loại xe"
                rules={[{ required: true }]}
              >
                <Select
                  onChange={(value) => {
                    updatePartnerFilter({ type: value });
                    resetActualData();
                  }}
                >
                  {types.map((t) => (
                    <Select.Option key={t.vhc_type_id} value={t.vhc_type_id}>
                      {t.vhc_type_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="promo_code" label="Mã giảm giá">
                <Input />
              </Form.Item>
            </Col>
            {/* <Col span={6}>
              <Form.Item name="cstm_deli_addr" label="Điểm giao xe">
                <Input />
              </Form.Item>
            </Col> */}
          </Row>
        </Card>
        <FormBookingUnsureGroup
          booking={booking}
          form={form}
          type="plan"
          selectedCity={selectedCity}
          selectedType={selectedType}
          onPartnerChange={onPartnerChange}
        />
        {booking && (
          <FormBookingUnsureGroup
            booking={booking}
            form={form}
            type="actual"
            selectedCity={selectedCity}
            selectedType={selectedType}
            onPartnerChange={onPartnerChange}
          />
        )}
        <Card className="mb-3">
          <Row gutter={16}>
            <Col span={3}>
              <Form.Item name="vhc_part_day_price" label="Giá thuê ngày (A)">
                <InputMoney onChange={calculateTotal} className="w-100" />
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item name="book_day_num_actual" label="Số ngày thuê (B)">
                <InputNumber step={0.5} onChange={calculateTotal} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                name="extra_fee"
                label="Phụ phí (C)"
                rules={[{ type: 'integer' }]}
                extra="Không bao gồm phụ phí ngày lễ, cuối tuần"
              >
                <InputMoney />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="book_price_total_actual"
                label="Tổng tiền booking (D)"
                extra="= A x B"
              >
                <InputMoney className="w-100" onChange={calculateRevenue} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                name="commission"
                label="Commission (E)"
                extra=" <100 thì là %, >100 thì là số tiền"
              >
                <InputMoney onChange={calculateRevenue} className="w-100" />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item name="promo_val" label="Khuyến mãi (F)">
                <InputMoney onChange={calculateRevenue} className="w-100" />
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item
                name="revenue"
                label="Chungxe thu về (G)"
                extra="= (D x E) - F, hoặc E - F"
              >
                <InputMoney className="w-100" readOnly />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Card className="mb-3">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="paid_amount"
                label="CX đã thu"
                extra="Bao gồm cả phí bảo hiểm"
              >
                <InputMoney className="w-100" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="paid_amount_insurance"
                label="Phí bảo hiểm đã thu"
                extra={
                  'Tiền thuê xe CX đã thu: ' +
                  (booking.paid_amount && booking.paid_amount_insurance
                    ? MyUtil.currencyFormat(
                        booking.paid_amount - booking.paid_amount_insurance
                      )
                    : 0)
                }
              >
                <InputMoney className="w-100" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="cstm_addr_live" label="Địa phương sinh sống">
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions('city_name', 'city_id', cities)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="book_rent_pupo"
                label="Mục đích thuê"
                rules={[{ required: true }]}
              >
                <RentPurposeSelect />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="book_schl" label="Lịch trình">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="book_resn_id" label="Nguyên nhân chưa lên L8">
                <Select
                  showSearch
                  onChange={failReasonDidChange}
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'book_resn_name',
                    'book_resn_id',
                    reasons
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['support_user']} label="CS phụ trách">
                <CustomSelect
                  dataSource={operators}
                  labelField="user_acc_full_name"
                  valueField="user_acc_id"
                  relatedDataField="user_acc_full_name"
                  relatedFormField="support_user_acc_full_name"
                  form={form}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['supply_side_operator_id']}
                label="SSO phụ trách"
              >
                <CustomSelect
                  dataSource={operators}
                  labelField="user_acc_full_name"
                  valueField="user_acc_id"
                  relatedDataField="user_acc_full_name"
                  relatedFormField="supply_side_operator_name"
                  form={form}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item name={['his_call']} label="Lịch sử cuộc gọi">
                <Input.TextArea rows={10} />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Row>
          <Col span={24}>
            <Form.Item name="book_code" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="book_id" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="support_user_acc_full_name" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="supply_side_operator_name" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="part_name" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="part_name_actual" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="vhc_part_name" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="vhc_part_name_actual" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="book_resn_name" hidden>
              <Input />
            </Form.Item>
            <Space>
              <Button htmlType="submit" type="primary">
                Lưu
              </Button>
              <Button type="default" onClick={() => props.history.go(-1)}>
                Quay lại
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
}

async function fetchSelectOptions() {
  const cities = await CityApi.getAll();
  const types = await TypeApi.getAll();
  const allReasons = await BookingApi.getReasons();
  const reasons = allReasons.filter((reason) => reason.enabled === true);
  const operators = await UserApi.getUserByGroupName('Operator');
  const operationAdmins = await UserApi.getUserByGroupName('Operation Admin');
  const sources = await BookingApi.getSources();

  return {
    cities,
    sources,
    types,
    reasons,
    operators: [...operators, ...operationAdmins],
  };
}

export default withRouter(FormBooking);
